export default "__VITE_ASSET__BH2t1Uo7__"